import { type Color, fontClasses, sizeClasses, type TextSize, type Weight } from "@/types/ui/design";
import React from "react";

type PennLabelProps = {
  children: React.ReactNode;
  size?: TextSize;
  color?: Color;
  font?: Weight;
  className?: string;
  htmlFor: string;
};

const PennLabel = ({
  children,
  size = "sm",
  color = "blue",
  font = "normal",
  className = "",
  htmlFor,
}: PennLabelProps) => {

  return (
    <label
      htmlFor={htmlFor}
      className={`${sizeClasses[size]} ${fontClasses[font]} ${className} text-${color}`}
    >
      {children}
    </label>
  );
};

export default PennLabel;